import cx from 'classnames';
import type { ChangeEvent, InputHTMLAttributes, ReactElement } from 'react';
import styles from './TextInput.module.scss';
import { inputTarget } from 'common/eventTargets';

type Props = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'value' | 'onChange' | 'className'
> & {
  type?: 'text' | 'search';
  value?: string;
  onValue: (value: string) => void;
  className?: string;
};

export function TextInput(props: Props): ReactElement {
  const { value, onValue, className, ...otherProps } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onValue(inputTarget(e).value);
  };
  return (
    <input
      {...otherProps}
      type={props.type || 'text'}
      value={value || ''}
      onChange={handleChange}
      className={cx(className, styles.input)}
    />
  );
}
